import { Grid, IconButton } from "@mui/material";
import { Close, Search } from "@mui/icons-material";
import { Box, DataTable, Modal, TextField, useCommonComponentContext } from "@maysoft/common-component-react";

import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import ResourceService from "../../services/identity/Resource.service";

import { useEffect, useState } from "react";
import { IRecordResource } from "../../commons/interfaces";

interface ISearchData {
    pageSize?: number;
    pageNumber?: number;
    totalCount?: number;
    searchText?: string;
}

const PopupAddLinkCourse = (props: {
    open: boolean;
    idSelected?: string;
    onClose: () => void;
    onAction: (data?: IRecordResource | undefined) => void;
}) => {
    const Strings = useStrings();

    const {
        language,
        serviceCode,
        organizationId,

        onError,
        onHideLoading,
        onShowLoading,
    } = useCommonComponentContext();

    const [rows, setRows] = useState<IRecordResource[]>([]);
    const [dataSelected, setDataSelected] = useState<string[]>([]);
    const [searchData, setSearchData] = useState<ISearchData>({} as ISearchData);
    const [itemSelected, setItemSelected] = useState<IRecordResource | undefined>(undefined);

    useEffect(() => {
        props.open && onGetpaged();
    }, [props.open]);

    useEffect(() => {
        if (Helpers.isNullOrEmpty(props.idSelected)) {
            setDataSelected([]);
        } else {
            setDataSelected([props.idSelected]);
        }
    }, [props.idSelected]);

    const onGetpaged = async (req?: ISearchData) => {
        try {
            onShowLoading();

            const pageSize = req?.pageSize || 10;
            const pageNumber = Helpers.getPageNumber(req?.pageNumber, pageSize, req?.totalCount || 0);

            const newReq: any = {
                serviceCode: serviceCode,
                organizationId: organizationId,
                pageSize: pageSize,
                pageNumber: pageNumber || 1,
                searchText: req?.searchText || undefined,
            };

            const result = await ResourceService.getPagedService(newReq);

            if (!Helpers.isNullOrEmpty(props.idSelected) && Helpers.isNullOrEmpty(itemSelected?.id)) {
                const itemTemp = [...(result?.items || [])].find((el) => el.id === props.idSelected);
                setItemSelected(itemTemp);
            }

            setRows([...(result?.items || [])]);

            setSearchData({
                pageSize: pageSize,
                totalCount: result?.totalCount,
                pageNumber: result?.currentPage,
                searchText: req?.searchText || undefined,
            });

            onHideLoading();
        } catch (error) {
            onHideLoading();
            const e = Helpers.renderExceptionError(error);
            onError(e);
        }
    };

    const handleAction = () => {
        props.onAction(itemSelected);
    };

    return (
        <>
            <Modal
                fullWidth
                hasActionButton
                visible={props.open}
                closeButton={Strings.Common.CANCEL}
                buttonAction={Strings.CHANNEL.CHOOSE_LINK_COURSE}
                title={Helpers.isNullOrEmpty(props.idSelected) ? Strings.CHANNEL.ADD_NEW_LINK_COURSE : Strings.CHANNEL.CHANGE_LINK_COURSE}
                onClose={() => {
                    props.onClose();
                }}
                onAction={dataSelected.length > 0 ? handleAction : undefined}
            >
                <>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box width="100%" p={0}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    maxLength={255}
                                    variant="outlined"
                                    key={searchData?.searchText}
                                    placeholder={Strings.Common.SEARCH_TEXT}
                                    defaultValue={searchData?.searchText || ""}
                                    onBlur={(e: any) => {
                                        const val = e.target?.value;
                                        setSearchData((prev) => ({ ...prev, searchText: val }));
                                    }}
                                    onKeyPress={(e: any) => {
                                        if (e.key === "Enter") {
                                            const val = e.target?.value;
                                            onGetpaged({ ...searchData, pageNumber: 1, searchText: val });
                                        }
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <IconButton
                                                color="info"
                                                onClick={() => {
                                                    const val = searchData?.searchText;
                                                    onGetpaged({ ...searchData, pageNumber: 1, searchText: val });
                                                }}
                                            >
                                                <Search />
                                            </IconButton>
                                        ),
                                        endAdornment: !Helpers.isNullOrEmpty(searchData?.searchText) && (
                                            <IconButton
                                                color="secondary"
                                                onClick={() => {
                                                    onGetpaged({ ...searchData, pageNumber: 1, searchText: undefined });
                                                }}
                                            >
                                                <Close />
                                            </IconButton>
                                        ),
                                    }}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <DataTable
                                allowCheckbox
                                multiSelected={false}
                                dataSelected={dataSelected}
                                handleOnChangeSelected={(data) => {
                                    setDataSelected(data);
                                    const itemTemp = rows.find((el) => el.id === data[0]);
                                    setItemSelected(itemTemp);
                                }}
                                rowPerPage={searchData?.pageSize}
                                pageNumber={searchData?.pageNumber}
                                totalCount={searchData?.totalCount}
                                onChangePageSize={(pageSize) => onGetpaged({ ...searchData, pageSize })}
                                onChangePageNumber={(pageNumber) => onGetpaged({ ...searchData, pageNumber })}
                                table={{
                                    rows: rows || [],
                                    columns: [
                                        { Header: "Code", accessor: "resourceCode", width: "120px" },
                                        {
                                            Header: "Name",
                                            accessor: "resourceName",
                                            width: "200px",
                                            Cell: (row) => <>{Helpers.getDefaultValueMultiLanguage(row?.value, language)}</>,
                                        },
                                    ],
                                }}
                            />
                        </Grid>
                    </Grid>
                </>
            </Modal>
        </>
    );
};

export default PopupAddLinkCourse;
